import { createContext, useEffect, useState } from "react";

export const PostsContext = createContext();

export const PostsProvider = ({ children }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cachedPosts = sessionStorage.getItem("posts");

    if (cachedPosts) {
      setPosts(JSON.parse(cachedPosts));
      setLoading(false);
    } else {
      const fetchAllPosts = async () => {
        let allPosts = [];
        let page = 1;
        const perPage = 100;
        let hasMore = true;

        try {
          while (hasMore) {
            const res = await fetch(
              `https://parmazing.net/wp-json/wp/v2/posts?per_page=${perPage}&page=${page}`
            );

            if (!res.ok) {
              throw new Error(`Failed to fetch page ${page}: ${res.status}`);
            }

            const data = await res.json();
            allPosts = [...allPosts, ...data];

            // If the returned page has less than `perPage`, we’re done
            hasMore = data.length === perPage;
            page++;
          }

          setPosts(allPosts);
          sessionStorage.setItem("posts", JSON.stringify(allPosts));
        } catch (error) {
        } finally {
          setLoading(false);
        }
      };

      fetchAllPosts();
    }
  }, []);

  return (
    <PostsContext.Provider value={{ posts, loading }}>
      {children}
    </PostsContext.Provider>
  );
};
